import * as messageBus from '@wh/message-bus';
import { Window } from './types';
declare let window: Window & typeof globalThis;
window.WH = window.WH || {};

window.WH.messageBus = window.WH.messageBus || messageBus;
